type Props = {
  absolutePath: string;
};
export default function HardcodedSection({ absolutePath }: Props) {
  return null;
}
